const GoogleMapsStyle = [
    {
        "featureType": "all",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#eae7d7"
            }
        ]
    },
    {
        "featureType": "all",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "visibility": "off"
            },
            {
                "weight": "10.00"
            },
            {
                "gamma": "10.00"
            },
            {
                "lightness": "100"
            },
            {
                "saturation": "100"
            }
        ]
    },
    {
        "featureType": "all",
        "elementType": "labels",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "landscape",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#d1ceba"
            }
        ]
    },
    {
        "featureType": "landscape",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#d1ceba"
            },
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "landscape",
        "elementType": "labels",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "landscape",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    }
]

const mapData = [
  {
    id: 1,
    location: 'Auckland, New Zealand',
    coords: { lat: -36.848, lng: 174.763 },
    city : 'Auckland',
    country: 'New Zealand',
    icon: 'eco'
  },
  {
    id: 2,
    location: 'Bangkok, Thailand',
    coords: { lat: 13.736, lng: 100.523 },
    city : 'Bangkok',
    country: 'Thailand',
    icon: 'markerTree100'
  },
  {
    id: 2,
    location: 'Tokyo, Japan',
    coords: { lat: 35.652, lng: 139.839 },
    city : 'Tokyo',
    country: 'Japan',
    icon: 'eco'
  },
  {
    id: 3,
    location: 'Geneva, England',
    coords: { lat: 51.504, lng: -0.143},
    city : 'Geneva',
    country: 'England',
    icon: 'eco'
  },
  {
    id: 4,
    location: 'Rio de Janeiro, Brazil',
    coords: { lat: -20.912, lng: -53.430},
    city : 'Rio de Janeiro',
    country: 'Brazil',
    icon: 'markerTree100'
  },
  {
    id: 5,
    location: 'Sydney, Australia',
    coords: { lat: -25.868, lng: 147.209 },
    city: 'Sydney',
    country: 'Australia',
    icon: 'eco'
  },
  {
    id: 15,
    location: 'Drysdale, Australia',
    coords: { lat: -15.368, lng: 126.909 },
    city: 'Drysdale',
    country: 'Australia',
    icon: 'tree'
  },
  {
    id: 15,
    location: 'New Guinea, Papua New Guinea',
    coords: { lat: -4.868, lng: 141.233 },
    city: 'New Guinea',
    country: 'Papua New Guinea',
    icon: 'tree'
  },
  {
    id: 6,
    location: 'Bogotá, Colombia',
    coords: { lat: 4.624, lng: -74.063 },
    city: 'Bogotá',
    country: 'Colombia',
    icon: 'eco'
  },
  {
    id: 7,
    location: 'Santiago, Chile',
    coords: { lat: -33.447, lng: -70.673 },
    city: 'Santiago',
    country: 'Chile',
    icon: 'eco'
  },
  // {
  //   id: 7,
  //   location: 'Caracas, Venezuela',
  //   coords: { lat: 10.202, lng: -66.910 },
  //   city: 'Loreto',
  //   country: 'Venezuela',
  //   icon: 'tree'
  // },
  {
    id: 8,
    location: 'Mexico, Mexico',
    coords: { lat: 17.730, lng: -93.390 },
    city: 'Mexico',
    country: 'Mexico',
    icon: 'tree'
  },
  {
    id: 9,
    location: 'California, USA',
    coords: { lat: 36.000, lng: -120.589 },
    city: 'California',
    country: 'USA',
    icon: 'eco'
  },
  {
    id: 10,
    location: 'Washington, USA',
    coords: { lat: 30.395, lng: -76.901 },
    city: 'Washington',
    country: 'USA',
    icon: 'markerTree100'
  },
  {
    id: 11,
    location: 'Ontario, Canada',
    coords: { lat: 51.326, lng: -105.346 },
    city: 'Ontario',
    country: 'Canada',
    icon: 'tree'
  },
  {
    id: 12,
    location: 'Ontario, Canada',
    coords: { lat: 55.326, lng: -85.346 },
    city: 'Ontario',
    country: 'Canada',
    icon: 'eco'
  },
  {
    id: 13,
    location: 'Yukon, Canada',
    coords: { lat: 53.068, lng: -136.346 },
    city: 'Yukon',
    country: 'Canada',
    icon: 'tree'
  },
  {
    id: 14,
    location: 'New York, USA',
    coords: { lat: 45.961, lng: -65.271 },
    city: 'New York',
    country: 'USA',
    icon: 'eco'
  }
]

export {GoogleMapsStyle , mapData};
// export default mapData;